import { ControlledRadioButton } from '@@viewCommonComponents/controlled';
import { isRequiredSelect } from '@@viewHelpers/validations';
import PropTypes from 'prop-types';

const SimulationNeedsGroupHealth = ({
  form,
  getMiddleText,
  getMiddleBoolean,
  displayIsEnforcedGuarantee,
  companyCcnHasAgreement
}) => {
  const groupHealthNeeds = [
    {
      value: false,
      label: getMiddleText('RECUEIL_BESOIN_TYPE_SOUHAIT_MIN_CCN_LABEL')
    },
    {
      value: true,
      label: getMiddleText('RECUEIL_BESOIN_TYPE_SOUHAIT_RENF_GAR_LABEL')
    }
  ];

  return (
    <ControlledRadioButton
      className={'flex flex-col gap-2'}
      name={'collectionNeeds.0.isEnforcedGuarantee'}
      options={groupHealthNeeds}
      isMultiline
      containerClassName="w-full flex flex-col gap-2"
      data-testid={'RECUEIL_BESOIN_TYPE_SOUHAIT'}
      label={getMiddleText('RECUEIL_BESOIN_TYPE_SOUHAIT_TITLE')}
      rules={isRequiredSelect(groupHealthNeeds, true)}
      form={form}
      isDisplayed={
        displayIsEnforcedGuarantee &&
        getMiddleBoolean('RECUEIL_BESOIN_TYPE_SOUHAIT_EST_NECESSAIRE') &&
        companyCcnHasAgreement
      }
    />
  );
};

SimulationNeedsGroupHealth.propTypes = {
  form: PropTypes.object,
  getMiddleText: PropTypes.func,
  getMiddleBoolean: PropTypes.func
};

export default SimulationNeedsGroupHealth;
